<script setup lang="ts">
import { GetStartetdPersonalSetupProps } from '@metras/frontend-shared/interfaces'

const PersonalSetupPhoneFormModel = defineModel<Pick<GetStartetdPersonalSetupProps, 'phoneNumber' | 'faxNumber'>>()
</script>

<template>
  <div class="flex flex-col gap-5 self-start w-full">
    <CustomInput v-model="PersonalSetupPhoneFormModel.phoneNumber" label="Telefonnummer" />
    <CustomInput v-model="PersonalSetupPhoneFormModel.faxNumber" label="Faxnummer" />
  </div>
</template>
